<template>
    <Modal id="ticket_reclassificar" :size="''" :open="show"
           :customSizeWid="'width:600px;margin: 0 auto;padding-top:4rem;'" :FooterDefault="false"
           :ClassBG="true" :customModalBody="'min-height:calc(100vh - 21rem);'">
        <template v-slot:header>
            <h6 class="modal-title">
                Reclassificar Ocorrência
            </h6>
            <button type="button" class="btn" data-bs-dismiss="modal" aria-label="Close">
                <i class="fas fa-times btn-close-style-v2 hover-effect"></i>
            </button>
        </template>
        <template v-slot:body>
            <div>
                <Form ref="Form_TrocarClassificacaoEtapa" @submit="submit_Form_TrocarClassificacaoEtapa">
                    <div class="row mt-3">
                        <div class="col">
                            <label class="form-label">Classificação</label>
                            <vue-select :options="ocorrencia_classificacoes"
                                        :label-by="(e) => (e.nmSetorClassificacao)"
                                        v-model="ocorrencia_classificacao"
                                        :class="{ filled: ocorrencia_classificacao.idSetorClassificacao > 0 }"
                                        placeholder="Digite o nome da Classificação e selecione"
                                        search-placeholder="Pesquise" searchable close-on-select clear-on-select
                                        :min="1" class="form-control shadow-v2">
                            </vue-select>
                            <Field name="idSetorClassificacao" label="Conta" type="hidden"
                                   rules="min_value:1"
                                   v-model="OcorrenciaClassificacaoEtapaCrud.idSetorClassificacao" />
                            <ErrorMessage name="idSetorClassificacao" class="form-error"
                                          v-show="showErrorMessage" />
                        </div>
                    </div>
                    <div class="row mt-3">
                        <div class="col">
                            <label class="form-label">Etapa</label>
                            <vue-select :options="classificacoes_etapas"
                                        :label-by="(e) => (e.nmSetorClassificacaoEtapa)"
                                        v-model="ocorrencia_classificacao_etapa"
                                        :class="{ filled: ocorrencia_classificacao_etapa.idSetorClassificacaoEtapa > 0 }"
                                        placeholder="Digite o nome da Etapa e selecione"
                                        search-placeholder="Pesquise" searchable close-on-select clear-on-select
                                        :min="1" class="form-control shadow-v2">
                            </vue-select>
                            <Field name="idSetorClassificacaoEtapa" label="Conta" type="hidden"
                                   rules="min_value:1"
                                   v-model="OcorrenciaClassificacaoEtapaCrud.idSetorClassificacaoEtapa" />
                            <ErrorMessage name="idSetorClassificacaoEtapa" class="form-error"
                                          v-show="showErrorMessage" />
                        </div>
                    </div>
                    <div class="row mt-3">
                        <div class="col">
                            <label for="exampleFormControlInput1" class="form-label">Motivo</label>
                            <textarea id="dsObservacao" class="form-control shadow-v2" rows="3"
                                      :class="{ filled: OcorrenciaClassificacaoEtapaCrud.dsObservacao }"
                                      v-model="OcorrenciaClassificacaoEtapaCrud.dsObservacao" required />
                            <ErrorMessage name="dsObservacao" class="form-error"
                                          v-show="showErrorMessage" />
                        </div>
                    </div>
                </Form>
            </div>
        </template>
        <template v-slot:footer>
            <div class="modal-footer">
                <button type="button" class="btn btn-close-clean-v2 mt-2" data-bs-dismiss="modal">
                    Fechar
                </button>
                <button type="button" class="btn btn-red-v2"
                        v-on:click="submit_Form_TrocarClassificacaoEtapa">
                    <i class='fas fa-save pe-2'></i>
                    Alterar Classificação Etapa
                </button>
            </div>
        </template>
    </Modal>
</template>

<script>

    import axios from "axios";
    import Modal from "@/components/App/Modal.vue";
    import VueNextSelect from 'vue-next-select'
    import 'vue-next-select/dist/index.min.css'

    export default {
        name: "Ocorrencia_Reclassificar",
        components: {
            'vue-select': VueNextSelect,
            Modal
        },
        props: {
            show: {
                type: Boolean,
                default: false
            },
            idOcorrencia: {
                type: Number,
                default: 0
            },
            cdSetor: {
                type: Number,
                default: 0
            },
            cdSetorClassificacao: {
                type: Number,
                default: 0
            },
            idModulo: {
                type: Number,
                default: 0
            },
        },
        data() {
            return {
                OcorrenciaClassificacaoEtapaCrud: {
                    idOcorrencia: 0,
                    idSetorClassificacao: 0,
                    idSetorClassificacaoEtapa: 0,
                    dsObservacao: ''
                },
                nmSetorClassificacao: 'Selecione a classificação',
                classificacoes_etapas: [],
                ocorrencia_classificacoes: [],
                ocorrencia_classificacao: { idSetorClassificacao: 0 },
                ocorrencia_classificacao_etapa: { idSetorClassificacaoEtapa: 0 },
                showErrorMessage: false,
            };
        },
        methods: {
            reset() {
                this.OcorrenciaClassificacaoEtapaCrud = {
                    idOcorrencia: 0,
                    idSetorClassificacao: 0,
                    idSetorClassificacaoEtapa: 0,
                    dsObservacao: ''
                };
                this.ocorrencia_classificacao = { idSetorClassificacao: 0 };
                this.ocorrencia_classificacao_etapa = { idSetorClassificacaoEtapa: 0 };
            },
            getOcorrenciaClassificacoes() {
                let $this = this;

                $this.ocorrencia_classificacoes = [];
                axios.get(process.env.VUE_APP_ROOT_COMERCIAL_API + '/SetorClassificacao/GetDropReclassificacao?cdSetor=' + $this.cdSetor + '&idModulo=' + $this.idModulo + '&cdSetorClassificacao=' + $this.cdSetorClassificacao, {
                    headers: $this.$api.getTokenComercial(),
                    notLoading: true
                }).then(response => {
                    $this.ocorrencia_classificacoes = response.data.data;
                })
            },
            async getClassificacaoEtapas(_cdSetorClassificacao) {
                let $this = this;
                const response = await axios.get(process.env.VUE_APP_ROOT_COMERCIAL_API + '/SetorClassificacaoEtapa/Get', {
                    headers: $this.$api.getTokenComercial(),
                    params: {
                        cdSetorClassficacao: _cdSetorClassificacao,
                        idModulo: $this.idModulo
                    },
                    notLoading: true
                });
                return response.data.data;
            },
            submit_Form_TrocarClassificacaoEtapa() {
                let $this = this;

                $this.OcorrenciaClassificacaoEtapaCrud.idOcorrencia = $this.idOcorrencia;

                $this.$refs.Form_TrocarClassificacaoEtapa.validate()
                    .then(isValid => {
                        if (isValid.valid) {
                            axios.post(process.env.VUE_APP_ROOT_COMERCIAL_API + '/Ocorrencia/PostTrocaDeSetorClassificacaoEtapa', $this.OcorrenciaClassificacaoEtapaCrud, { headers: $this.$api.getTokenComercial() })
                                .then(function (response) {
                                    $this.$emit('fechou_modal');
                                })
                                .catch(function (error) {
                                    var msg = 'Ocorreu um erro inesperado';
                                    if (error.response) {
                                        if (error.response.data.erros != '') {
                                            msg = error.response.data.errors[0];
                                        } else {
                                            msg = error.response.data.msg;
                                        }
                                    }

                                    $this.$toast.show('alert', msg, true);
                                });
                            $this.showErrorMessage = false;
                        } else {
                            throw new Error();
                        }
                    })
                    .catch(error => {
                        var msg = 'Por favor, preencha todos os campos obrigatorios';
                        if (error.response) {
                            if (error.response.data.erros != '') {
                                msg = error.response.data.errors[0];
                            } else {
                                msg = error.response.data.msg;
                            }
                        }
                        $this.showErrorMessage = true;
                        $this.$toast.show('alert', msg, true);
                    });
            },
        },
        watch: {
            show(n, o) { this.getOcorrenciaClassificacoes(); this.reset(); },
            cdSetor(new_value, old_value) { },
            ocorrencia_classificacao: async function (_new, _old) {
                this.classificacoes_etapas = [];
                this.OcorrenciaClassificacaoEtapaCrud.idSetorClassificacao = _new.idSetorClassificacao;
                this.classificacoes_etapas = await this.getClassificacaoEtapas(_new.cdSetorClassificacao);
            },
            ocorrencia_classificacao_etapa(_new, _old) {
                this.OcorrenciaClassificacaoEtapaCrud.idSetorClassificacaoEtapa = _new.idSetorClassificacaoEtapa;
            },
        },
    };

</script>


<style scoped lang="scss">
</style>